import { gql } from "generated-graphql";

/**
 * The newest month the tenant has been invoiced for, which is where the tabs
 * open when the reader has not chosen a period.
 */
export const LATEST_INVOICED_PERIOD_QUERY = gql(`
  query LatestInvoicedPeriod($tenantId: ID!) {
    wasteInvoices(
      tenantId: $tenantId
      pageSize: 1
      sort: [{ field: "servicePeriodEnd", sort: "desc" }]
    ) {
      items {
        id
        servicePeriodEnd
      }
    }
  }
`);
